// extracted by mini-css-extract-plugin
export default {"latoFont":"\"Lato\",sans-serif","colorShade60":"#676979"};